// extracted by mini-css-extract-plugin
export var deliveryRow = "_p5-a";
export var fixedHeight = "_p5-4";
export var freightLogo = "_p5-9";
export var fullWidth = "_p5-3";
export var priceColumn = "_p5-5";
export var radioSelected = "_p5-7";
export var radioUnselected = "_p5-6";
export var selectedOption = "_p5-2";
export var selectedOptionContainer = "_p5-1";
export var selection = "_p5-0";
export var tallSkeletonText = "_p5-8";